import { render } from "./DownloadThumbnailsButton.component.vue?vue&type=template&id=5d718baa&ts=true"
import script from "./DownloadThumbnailsButton.component.vue?vue&type=script&lang=ts"
export * from "./DownloadThumbnailsButton.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__